import { PersonModel } from '@/types';

export const person: PersonModel = {
  name: 'Wojciech',
  surname: 'Cywiński',
  position: 'Senior Frontend Developer',
  linkedinLink: 'https://pl.linkedin.com/in/wojciech-cywinski'
};
